// axios adapter — POS route-larını pos_local-a yönləndirir.
// Mövcud komponentlərin `axios.get(${base_url}/...)` çağırışları DƏYİŞMİR;
// interceptor (install.ts) yalnız config.adapter-i bununla əvəz edir.

import type { AxiosAdapterFn, MatchedConfig } from './types';
import { matchPosRoute, PosRouteContext } from './routes';

/** axios config.url + baseURL-dən pathname və query çıxar. */
function parseUrl(config: MatchedConfig): { pathname: string; query: Record<string, string> } {
  const raw = config.url || '';
  let full = raw;
  if (config.baseURL && !/^https?:\/\//i.test(raw)) {
    full = config.baseURL.replace(/\/+$/, '') + '/' + raw.replace(/^\/+/, '');
  }
  try {
    const u = new URL(full, 'http://_local_');
    const query: Record<string, string> = {};
    u.searchParams.forEach((v, k) => (query[k] = v));
    // axios `params` da query verə bilər
    if (config.params && typeof config.params === 'object') {
      for (const [k, v] of Object.entries(config.params)) {
        if (v !== undefined && v !== null) query[k] = String(v);
      }
    }
    return { pathname: u.pathname, query };
  } catch {
    return { pathname: full, query: {} };
  }
}

/** Verilən config üçün uyğun POS route varsa, onu icra edən adapter qaytar. */
export function resolvePosAdapter(config: MatchedConfig): AxiosAdapterFn | null {
  const { pathname, query } = parseUrl(config);
  const ctx: PosRouteContext = {
    method: (config.method || 'get').toUpperCase(),
    pathname,
    query,
    body: config.data,
  };
  const route = matchPosRoute(ctx);
  if (!route) return null;

  // axios transformRequest config.data-nı string-ə çevirir (adapter-dən əvvəl).
  // Route handler obyekt gözləyir → parse edirik.
  if (typeof ctx.body === 'string') {
    try {
      ctx.body = JSON.parse(ctx.body);
    } catch {
      /* string qalsın */
    }
  }

  return async () => {
    try {
      const result = await route.run(ctx);
      return {
        data: result.data,
        status: result.status,
        statusText: 'OK',
        headers: {},
        config,
        request: { __posGateway: true },
      };
    } catch (e) {
      const err = e as Error & { posCode?: string; posStatus?: number };
      const status = err.posStatus ?? 500;
      // axios-uyğun error: komponentlərin catch-i error.response.status / .data.message gözləyir
      const axiosErr = new Error(err.message) as Error & {
        response?: unknown;
        config?: unknown;
        isAxiosError?: boolean;
        isPosGateway?: boolean;
      };
      axiosErr.isAxiosError = true;
      // POS gateway mənbəli xəta — qlobal 401 interceptor-u cloud token-ini
      // silməsin (POS ayrı pos_token işlədir). Bax: index.tsx.
      axiosErr.isPosGateway = true;
      axiosErr.config = config;
      axiosErr.response = {
        status,
        statusText: 'Error',
        data: { message: err.message, code: err.posCode },
        headers: {},
        config,
      };
      throw axiosErr;
    }
  };
}
